import Box from '@mui/material/Box'
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import * as React from 'react'

const CircularProgressWithLabel = (props: CircularProgressProps & { value: number }) => {
  const { value } = props

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">{`${Math.round(value)}%`}</Typography>
      </Box>
    </Box>
  )
}

interface ProgressBarProps {
  value?: number
}

const ProgressBar: React.FC<ProgressBarProps> = ({ value }) => {
  const [progress, setProgress] = React.useState(value || 5)

  React.useEffect(() => {
    if (value !== undefined) {
      setProgress(value)
    } else {
      const timer = setInterval(() => {
        setProgress(prevProgress => (prevProgress >= 95 ? 99 : prevProgress + 5))
      }, 1000)
      return () => {
        clearInterval(timer)
      }
    }
  }, [value])

  return <CircularProgressWithLabel value={progress} />
}

export default ProgressBar
